import ResetPasswordView from "./ResetPasswordView";

export const ResetPasswordContainer = () => {
  return (
    <div>
      <ResetPasswordView />
    </div>
  );
};
